import { Record as record } from 'immutable';

import { construct, resolveAll } from '../../helpers/LinkMapper';
import { getDefaults } from '../../helpers/Records';
import TicketRefundCalculation from './TicketRefundCalculation';

const fieldSchema = {
    adminFee: null,
    tickets: null,
};

class StoredRefundCalculations extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(StoredRefundCalculations, json, {
            adminFee: json.adminFee,
            tickets: resolveAll(json.tickets).as(TicketRefundCalculation),
        });
    }
}

export default StoredRefundCalculations;



// WEBPACK FOOTER //
// ./src/records/refund/StoredRefundCalculations.js